import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';

import { captureReferralCodeFromUrl } from '@/shared/lib/referral';

/**
 * Persists the `?ref=CODE` query param on landing so the sign-up can attribute
 * the new account to the referring affiliate (first-party referral tracking).
 */
export function ReferralProvider({ children }: PropsWithChildren) {
    useEffect(() => {
        captureReferralCodeFromUrl();
    }, []);

    return children;
}
